import apiClient from "../../api/apiClient";

const oemApi = {
  addPartner: async (data) => {
    const formData = new FormData();
    
    Object.keys(data).forEach(key => {
      if (key === 'logo' && data[key]) {
        formData.append('logo', data[key]);
      } else if (key === 'stripeProductId' && Array.isArray(data[key])) {
        formData.append('stripeProductId', JSON.stringify(data[key]));
      } else if (key !== 'logo' && key !== 'refreshParams' && data[key] !== null && data[key] !== undefined) {
        formData.append(key, data[key]);
      }
    });

    const response = await apiClient.post('/partners/oem-partners', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  getPartners: async (params = {}) => {
    const { limit = 10, page = 1, search = '', status = '', _id} = params;
    const response = await apiClient.get('/partners/itsales-partners/oem-partners/list', {
      params: { limit, page, search, status, _id }
    });
    return response.data;
  },

  editPartner: async (data) => {
    const { id, ...editData } = data;
    const formData = new FormData();
    
    Object.keys(editData).forEach(key => {
      if (key === 'logo' && editData[key]) {
        formData.append('logo', editData[key]);
      } else if (key === 'stripeProductId' && Array.isArray(editData[key])) {
        formData.append('stripeProductId', JSON.stringify(editData[key]));
      } else if (key !== 'logo' && key !== 'refreshParams' && editData[key] !== null && editData[key] !== undefined) {
        formData.append(key, editData[key]);
      }
    });

    const response = await apiClient.put('/partners/oem-partners', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      params: { id }
    });
    return response.data;
  },

  deletePartner: async (id) => {
    const response = await apiClient.delete('/partners/oem-partners', {
      data: { _id: id }
    });
    return response.data;
  },

  changeStatus: async (data) => {
    const { refreshParams, ...statusData } = data;
    const response = await apiClient.patch('/partners/itsales-partners/oem-partners/status', statusData);
    return response.data;
  },

  getScanTypes: async () => {
    const response = await apiClient.get('/partners/itsales-partner/scan-types/license');
    return response.data;
  },

  getOemNames: async () => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    const itsalesId = user?.itSalesPartner?.id;
    const response = await apiClient.get(`/partners/itsales-partner/oem-partners/names/${itsalesId}`);
    return response.data;
  },

   resetPassword: async (data) => {
    const response = await apiClient.post('/partners/itsales-partner/oem-partners/reset-password', {
      oemId: data.oemId,
      password: data.password
    });
    return response.data;
  },

  getLicenses: async (params = {}) => {
    const { search = '' } = params;
    const user = JSON.parse(sessionStorage.getItem('user'));
    const itsalesId = user?.itSalesPartner?.id;
    
    const response = await apiClient.get('/partners/itsales-partner/licenses/assigned', {
      params: { search, itsalesId }
    });
    return response.data;
  },

  getLicensesList: async (params = {}) => {
    const { search = '' } = params;
    const user = JSON.parse(sessionStorage.getItem('user'));
    const itsalesId = user?.itSalesPartner?.id;
    
    const response = await apiClient.get(`/partners/itsales-partner/licenses/list/${itsalesId}`, {
      params: { search }
    });
    return response.data;
  },

  getOemPartnerUsers: async (params = {}) => {
    const { page = 1, limit = 10, search = '', oemId } = params;
    const response = await apiClient.get('/partners/itsales-partners/oem-partners/user-list', {
      params: { page, limit, search, oemId }
    });
    return response.data;
  }
};

export { oemApi };